import { ReactNode, useState, useEffect } from 'react';

import { Box } from '@mui/joy';

const CampaignDashboardLayout: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isFullScreen, setIsFullScreen] = useState(false);
  useEffect(() => {
    // # TODO: This is a hack to check if the campaign is full screen
    setIsFullScreen(window.location.pathname.includes('/crew/'));
  }, []);

  return (
    <Box className={`w-full h-screen max-h-screen ${!isFullScreen ? 'p-4' : ''}`}>
      <Box className='w-full h-full relative z-50'>{children}</Box>
    </Box>
  );
};

export default CampaignDashboardLayout;
